/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import { observer } from 'mobx-react'
import { TitleWrap } from '@styles/base.style'
import { useOnMount } from '@utils/reactExt'
import useRootStore from '@store/useRootStore'
import MoneyHistoryList from '@views/MyBank/MoneyHistoryList'
import { HISTORY_TYPE } from '@constants/index'
import { BackBtn } from '@styles/button.style'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import MoneyHistoryTab from './MoneyHistoryTab'
import ItemHistoryList from './ItemHistoryList'
import { appScrollTo } from '@utils/utils'

interface MyBankProps {
  historyType?: HISTORY_TYPE
}

const MyBank: React.FC<MyBankProps> = (props: MyBankProps) => {
  const { authStore, routerStore } = useRootStore()
  const { historyType = HISTORY_TYPE.MONEY } = props

  useOnMount(() => {
    if (!authStore.isSignedIn) {
      routerStore.push('/')
    }

    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  return (
    <Fragment>
      {historyType === HISTORY_TYPE.MONEY && (
        <Fragment>
          {isMobile && (
            <TitleWrap className="title-wrap white">
              <BackBtn onClick={() => routerStore.goBack()}>
                <ArrowIco/>
              </BackBtn>
            </TitleWrap>
          )}
          <MoneyHistoryTab/>
          <MoneyHistoryList/>
        </Fragment>
      )}
      {historyType === HISTORY_TYPE.ITEM && (
        <ItemHistoryList/>
      )}
    </Fragment>
  )
}

export default observer(MyBank)
